var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HearingAbilityContent } from '@/components/hearing-ability-content.component';
import { useStyledModal } from '@/hooks/use-styled-modal.hook';
import { ButtonBase, Typography } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
function Modal() {
    return (_jsxs("div", __assign({ className: "flex flex-col gap-4 text-center" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: 'text-3xl' }, { children: "Your hearing test results:" })), _jsx("div", __assign({ className: "rounded-xl bg-faux-white shadow-lg p-5 sm:p-6 flex flex-col max-w-[640px]" }, { children: _jsx(HearingAbilityContent, {}) }))] })));
}
export function HearingResultsPopup() {
    var _a = useStyledModal(_jsx(Modal, {})), modal = _a[0], toggleModal = _a[1];
    var sendButtonClick = useAnalytics().sendButtonClick;
    function onClick() {
        toggleModal();
        sendButtonClick('result_explainer');
    }
    return (_jsxs("div", __assign({ className: 'flex flex-col items-center justify-center gap-2 mt-8 md:mt-0' }, { children: [modal, _jsx(ButtonBase, __assign({ onClick: onClick }, { children: _jsx(Typography, __assign({ className: "text-primary underline text-lg text-center" }, { children: "Learn more about my results" })) }))] })));
}
export function DiscountMessage() {
    return (_jsxs(Typography, __assign({ className: "text-lg text-center max-w-[480px]" }, { children: ["Use coupon code ", _jsx("strong", { children: "\u2018HEAR50\u2019" }), " in checkout to claim your", ' ', _jsxs("strong", { children: [_jsx("br", { className: 'md:hidden' }), " $50 discount on select Lexie hearing aids."] })] })));
}
